// Glossary of terms used throughout the application
export const glossary = {
  'Target Separation': 'How close two objects (like fish) can be and still be shown as separate on the sonar.',
  'Beam Angle': 'The width of the sonar cone. Wider angles cover more area but may reduce detail.',
  'Black Box Required': 'Whether a separate processing module (GLS 10) is needed for this transducer.',
  'Imaging Modes': 'The different viewing modes (Forward, Down, Perspective) supported by the transducer.',
  'Max Range': 'Maximum distance the sonar can scan in freshwater.',
  'Power Draw': 'The amount of electrical current (in amps) that the unit draws from the battery.',
  'MSRP': 'Manufacturer\'s Suggested Retail Price - the price set by the manufacturer.',
  'Screen Size': 'The diagonal measurement of the display screen in inches.',
  'Resolution': 'The number of pixels on the screen, affecting image clarity and detail.',
  'Battery Type': 'The chemical composition of the battery, affecting performance and weight.',
  'Amp Hours': 'A measure of the battery\'s capacity - how long it can provide power before needing recharging.',
  'Dimensions': 'The physical size of the product (length, width, height).',
}; 